/**
 * The driver's OFFLINE START.
 *
 * The portal's normal gate waits up to five seconds on a "who am I" call and,
 * if it fails, sends the person to the login page - which strands a driver who
 * opens the app in a dead zone. So the driver view remembers who last signed
 * in on this phone, and opens straight to that person's cached route when the
 * network cannot answer.
 *
 * This is NOT a credential. It holds an id, a name and the role flag - nothing
 * that authenticates anything. Every upload still needs the httpOnly cookie;
 * with no valid cookie the queue keeps the stop and says "sign in to upload".
 */
import { getMeta, setMeta } from './db';

export interface DriverSession {
  userId: number;
  username: string;
  name: string;
  canManage: boolean;
  savedAt: number;
}

const KEY = 'driverSession';

export async function getDriverSession(): Promise<DriverSession | undefined> {
  return getMeta<DriverSession>(KEY);
}

export async function saveDriverSession(s: Omit<DriverSession, 'savedAt'>): Promise<DriverSession> {
  const session = { ...s, savedAt: Date.now() };
  await setMeta(KEY, session);
  return session;
}

export async function clearDriverSession(): Promise<void> {
  await setMeta(KEY, undefined);
}
